// src/components/RestaurantsProvider.tsx
import React from 'react';
import { createHimmaClient } from '../Context/Auth/AuthenticatedApiClient';
import { HimmaContext } from '../Context/HimmaContext';

type HimmaProviderProps = {
  children: React.ReactNode;
  baseUrl: string;
}

export const HimmaProvider: React.FC<HimmaProviderProps> = ({
  children,
  baseUrl,
}) => {
  const HimmaClient = createHimmaClient(baseUrl);

  return (
    <HimmaContext.Provider value={HimmaClient}>
      {children}
    </HimmaContext.Provider>
  );
};
